import { Col, Text } from 'components';
import { theme } from 'lib';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin: ${(props) => props.marg || 0};
  height: ${(props) => (props.small ? 44 : 56)}px;
  background-color: ${theme.GREY_10};
  border-radius: 50px;
  align-items: center;
  display: flex;
  padding: 0 4px;
  width: ${(props) => props.wid};

  @media (max-width: 1024px) {
    height: 44px;
  }
`;

const Option = styled.div`
  display: flex;
  height: ${(props) => (props.small ? 36 : 48)}px;
  background-color: ${(props) => (props.selected ? theme.SECONDARY : 'transparent')};
  border-radius: 50px;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.wid};
  cursor: pointer;
  position: relative;

  @media (max-width: 1024px) {
    height: 36px;

    p {
      font-size: 14px;
    }
  }
`;

const SegmentControl = ({
  options,
  selectedIdx,
  handleSelect,
  marg,
  small,
  wid,
  textStyle = {},
  subtitles
}) => {
  return (
    <Wrapper wid={wid} marg={marg} small={small}>
      {options.map((opt, i) => (
        <Option
          onClick={() => handleSelect(i)}
          wid={`${100 / options.length}%`}
          selected={selectedIdx === i}
          key={i}
          small={small}
        >
          <Text
            size="18px"
            bold={selectedIdx === i}
            col={selectedIdx === i && '#fff'}
            {...textStyle}
          >
            {opt}
          </Text>

          {selectedIdx !== i && subtitles?.length > i && subtitles[i] && (
            <Col pos="absolute" marg="30px" pad="2px 8px" bg={theme.GREY_20} hasRadius="16px">
              <Text c1 bold>
                {subtitles[i]}
              </Text>
            </Col>
          )}
        </Option>
      ))}
    </Wrapper>
  );
};

export default SegmentControl;
